import { RouterModule }  from "@angular/router";
import { LostCredentialsComponent } from "./lostCredentials.component";
import { LostCredentialsConfirmation } from "./lostCredentials.confirmation";

export const CREDENTIALROUTING = RouterModule.forChild([
  { path: "lostCredentials", component: LostCredentialsComponent},
   { path: "lostCredentialsConfirmation", component: LostCredentialsConfirmation}
]);


// WEBPACK FOOTER //
// ./src/app/modules/lostCredentials/lostCredentials.route.ts